import { jsx as _jsx } from "react/jsx-runtime";
import { SearchIcon } from '../assets';
import { CustomInput } from './styles';
const SearchInput = (props) => {
    return _jsx(CustomInput, { ...props, icon: _jsx(SearchIcon, {}) });
};
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map